import { createStore } from 'vuex';


import projectDetails from '@/store/projectDetails';
import auth from '@/store/auth';
import fileDetails from '@/store/fileDetails';
import sampleDetails from '@/store/sampleDetails';
import feedbackDetails from '@/store/feedbackDetails';
import clipboard from '@/store/clipboard'


export default createStore({
  modules: {
    auth,
    projectDetails,
    fileDetails,
    sampleDetails,
    feedbackDetails,
    clipboard
  }
})
